import React from "react";
import { ClipPath, Defs, G, Path, Rect, Svg } from "react-native-svg";

export function CaretDownFill({
  width = 20,
  height = 20,
  color = "#33393D",
  strokeColor = "#5A6066",
  ...props
}) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <Defs>
        <ClipPath id="clip0_5397_41433">
          <Rect width="20" height="20" fill="white" />
        </ClipPath>
      </Defs>
      <G clipPath="url(#clip0_5397_41433)">
        <Path
          d="M16.2499 6.91407L16.2501 6.91407C16.3657 6.9137 16.4789 6.94759 16.5754 7.01146C16.6717 7.07523 16.747 7.16605 16.7919 7.27249C16.8341 7.38093 16.8447 7.49909 16.8227 7.61335C16.8006 7.72758 16.7467 7.83324 16.6672 7.91815L10.4181 14.1672C10.418 14.1673 10.4179 14.1674 10.4179 14.1675C10.3057 14.2758 10.1559 14.3363 9.99994 14.3363C9.844 14.3363 9.69416 14.2758 9.58201 14.1675C9.58193 14.1674 9.58186 14.1673 9.58178 14.1672L3.33269 7.91814C3.25318 7.83323 3.19929 7.72757 3.17722 7.61335C3.15515 7.49909 3.16583 7.38093 3.20802 7.27248C3.25287 7.16604 3.32818 7.07523 3.42449 7.01146C3.52094 6.94759 3.63414 6.9137 3.74982 6.91407H3.74994L16.2499 6.91407Z"
          fill={color}
          stroke={strokeColor}
          strokeWidth="0.078125"
        />
      </G>
    </Svg>
  );
}
